import React, { useState, useEffect } from 'react';
import { MdLock, MdReplay } from 'react-icons/md';
import toast from 'react-hot-toast';
import { validateOtp, resendOtp } from '../../services/rgpdService';
import CopyrightInfo from '../Common/CopyrightInfo';

export default function RGPDValidateOTP({ token, clientName, onValidated }) {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  // 🔹 Countdown de 60s entre reenvios
  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [cooldown]);

  // 🔹 Submissão do código OTP
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const res = await validateOtp(token, otp);
      toast.success('Validação concluída.');
      onValidated(res.sessionToken);
    } catch {
      toast.error('Código inválido ou expirado. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Reenvio do código OTP via SMS
  const handleResend = async () => {
    try {
      setResendLoading(true);
      await resendOtp(token);
      toast.success('Novo código enviado por SMS.');
      setCooldown(60); // 60s de espera
    } catch {
      toast.error('Não foi possível reenviar o código. Tente novamente.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="text-center">
      <div className="flex justify-center items-center rounded-md bg-green-100 py-3 px-6 text-green-800 mb-6">
        <MdLock className="h-5 w-5 text-green-700 mr-2" />
        <span className="font-bold text-base md:text-base text-xs">
          Introduza o código de segurança recebido por SMS.
        </span>
      </div>

      <p className="text-gray-700 text-base mb-3">
        Olá <strong>{clientName}</strong>, introduza o <b>código OTP</b> de 6 dígitos que recebeu.
      </p>

      <input
        type="text"
        maxLength={6}
        value={otp}
        onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
        className="border border-gray-300 text-center rounded-md p-2 w-32 text-lg font-bold tracking-widest"
      />

      <div>
        <button
          onClick={handleSubmit}
          disabled={loading || otp.length !== 6}
          className={`mt-6 px-6 py-2 rounded-md text-white font-medium transition ${
            loading || otp.length !== 6
              ? 'bg-gray-300 cursor-not-allowed'
              : 'bg-[#004775] hover:bg-[#0C92AF]'
          }`}
        >
          {loading ? 'A Validar...' : 'Confirmar Código'}
        </button>
      </div>

      <div className="mt-6">
        <button
          onClick={handleResend}
          disabled={resendLoading || cooldown > 0}
          className={`inline-flex items-center gap-1 px-4 py-2 rounded-md text-sm font-medium transition ${
            resendLoading || cooldown > 0
              ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
              : 'bg-gray-100 hover:bg-gray-200 text-[#004775]'
          }`}
        >
          <MdReplay className="h-4 w-4" />
          {resendLoading
            ? 'A reenviar...'
            : cooldown > 0
            ? `Reenviar código (${cooldown}s)`
            : 'Reenviar código'}
        </button>
      </div>

      <div className="mt-10 text-gray-600 text-sm">
        O código expira em <b>10 minutos</b> por razões de segurança.
      </div>

      <CopyrightInfo className="mt-10" />
    </div>
  );
}